import { render, staticRenderFns } from "./delivery-planification.vue?vue&type=template&id=567fe24e&"
import script from "./delivery-planification.vue?vue&type=script&lang=js&"
export * from "./delivery-planification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports